import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '../../services/translate.service';
import { BorderIconButtonComponent } from '../buttons/border-icon-button.component';
import { CircleButtonComponent } from '../buttons/circle-button.component';
import { BottomSheetService } from '../../services/bottom-sheet.service';
import { LoadingSpinnerComponent } from './loading-spinner-component';
import { LangConfirmService } from '../../services/lang-confirm.service';
import {ConfirmLangDialogComponent} from './confirm-lang-dialog.component';

@Component({
  standalone: true,
  imports: [CommonModule, BorderIconButtonComponent, CircleButtonComponent, LoadingSpinnerComponent, ConfirmLangDialogComponent],
  selector: 'app-select-lang',
  template: `
    <div *ngIf="!isLoading" class="w-full">
      <div class="flex flex-col gap-4 pb-8">
        <div class="flex flex-col gap-3">
          <div *ngFor="let lang of languages" (click)="selectLang(lang)">
            <app-border-icon-button text="{{lang.flag}}&nbsp;&nbsp;{{lang.name}} ({{lang.code}})" (onClick)="selectLang(lang)"></app-border-icon-button>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isLoading" class="flex justify-center items-center py-16">
      <app-loading-spinner></app-loading-spinner>
    </div>

    <!-- Language confirmation dialog -->
    <div *ngIf="showConfirmDialog" class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div class="bg-theme-surface rounded-xl p-6 max-w-md w-full mx-4">
        <app-confirm-lang-dialog
          [lang]="selectedLang"
          (onClose)="closeConfirmDialog()"
          (onConfirm)="confirmLangChange($event)">
        </app-confirm-lang-dialog>
      </div>
    </div>
  `
})
export class SelectLangComponent implements OnInit {
  public isLoading: boolean = false;
  public showConfirmDialog: boolean = false;
  public selectedLang: any = null;

  languages = [
    {code: "sv", name: "Svenska", flag: "🇸🇪"},
    {code: "en", name: "English", flag: "🇬🇧"},
    {code: "zh", name: "汉语", flag: "🇨🇳"},
    {code: "es", name: "Español", flag: "🇪🇸"},
    {code: "fr", name: "Français", flag: "🇫🇷"},
    {code: "de", name: "Deutsch", flag: "🇩🇪"},
    {code: "pt", name: "Português", flag: "🇵🇹"},
    {code: "it", name: "Italiano", flag: "🇮🇹"},
    {code: "ja", name: "日本語", flag: "🇯🇵"},
    {code: "ko", name: "한국어", flag: "🇰🇷"},
    {code: "ar", name: "العربية", flag: "🇸🇦"},
    {code: "tr", name: "Türkçe", flag: "🇹🇷"},
    {code: "vi", name: "Tiếng Việt", flag: "🇻🇳"},
    {code: "nl", name: "Dutch", flag: "🇳🇱"},
    {code: "da", name: "Dansk", flag: "🇩🇰"},
    {code: "fi", name: "Suomi", flag: "🇫🇮"},
    {code: "no", name: "Norsk", flag: "🇳🇴"},
    {code: "is", name: "Íslenska", flag: "🇮🇸"},
    {code: "he", name: "עברית", flag: "🇮🇱"},
    {code: "hi", name: "हिन्दी", flag: "🇮🇳"},
    {code: "id", name: "Bahasa Indonesia", flag: "🇮🇩"},
    {code: "mr", name: "मराठी", flag: "🇮🇳"},
    {code: "tl", name: "Tagalog", flag: "🇵🇭"},
    {code: "pl", name: "Polski", flag: "🇵🇱"},
    {code: "sk", name: "Slovenský", flag: "🇸🇰"},
    {code: "th", name: "ภาษาไทย", flag: "🇹🇭"},
    {code: "uk", name: "Українська", flag: "🇺🇦"},
  ];

  constructor(
    protected translate: TranslateService,
    private langConfirmService: LangConfirmService,
    private sheetService: BottomSheetService
  ) { }

  ngOnInit(): void {
  }

  selectLang(lang: any) {
    if (lang.code === "sv") {
      localStorage.setItem("collinsLang", lang.code);
      window.location.reload();
      return;
    }

    this.selectedLang = lang;
    this.showConfirmDialog = true;
  }

  closeConfirmDialog() {
    this.showConfirmDialog = false;
    this.selectedLang = null;
  }

  confirmLangChange(lang: any) {
    localStorage.setItem("collinsLang", lang.code);
    window.location.reload();
  }
}
